

































import ResponsiveImage from '@/components/common/Image.vue';
import Health from '@/graphql/queries/health.gql';
import request from '@/graphql/request';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class Home extends Vue {
  @Prop() public msg!: string;

  public health = 'unknown';
  public title = 'Knock Down the House';
  public subtitle = 'Empowering your voice in politics';
  public campaigns: { name: string } = { name: 'List of Campaigns' };
  public about: { name: string } = { name: 'Who We Are' };

  public mounted() {
    request(Health)
      .then(({ data }) => (this.health = data.health))
      .catch(() => (this.health = 'The API is currently unreachable'));
  }
}
